// extracted by mini-css-extract-plugin
export var ctaLink = "index-module--ctaLink--+GMcs";
export var ctaLinkArrow = "index-module--ctaLinkArrow--WW-I6";
export var ffColumn = "index-module--ffColumn---m4CZ";
export var ffColumnContainer = "index-module--ffColumnContainer--VnSyL";
export var ffDark = "index-module--ffDark--OJxv5";
export var ffHeadingContainer = "index-module--ffHeadingContainer--GGvjd";
export var ffImageLeft = "index-module--ffImageLeft--YsGDd";
export var ffImageRight = "index-module--ffImageRight--J7Txy";
export var ffInnerContainer = "index-module--ffInnerContainer--R9l8b";
export var ffOuterContainer = "index-module--ffOuterContainer--AuGOY";
export var ffTextContainer = "index-module--ffTextContainer--16Rm7";